import React from 'react';
import { Section } from './Section';
import { MessageCircleHeart } from 'lucide-react';
export function ProofSection() {
  const testimonials = [{
    text: 'Me ayudó a organizarme y dejar de sentirme tan pesada al final del día. Lo mejor es que está súper fácil de seguir.',
    name: 'María G.',
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'Sentí más control, menos inflamación y me encantó que todo está pensado para mujeres como nosotras que vivimos en USA.',
    name: 'Carolina R.',
    photo: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=100&h=100&fit=crop&crop=face'
  }];
  return <Section className="bg-sage" data-id="element-130">
      <div className="text-center mb-12" data-id="element-131">
        <MessageCircleHeart className="w-12 h-12 text-forest mx-auto mb-4" data-id="element-132" />
        <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-6" data-id="element-133">
          Lo que otras mujeres han sentido con esta guía
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-134">
        {testimonials.map((item, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-lg relative" data-id="element-135">
            <div className="text-gold text-4xl font-serif absolute top-4 left-4 opacity-30" data-id="element-136">
              "
            </div>
            <p className="text-gray-700 text-lg italic relative z-10 pt-4" data-id="element-137">
              {item.text}
            </p>
            <div className="mt-6 flex items-center gap-3" data-id="element-138">
              <img src={item.photo} alt={item.name} className="w-10 h-10 rounded-full object-cover" data-id="element-139" />
              <span className="font-semibold text-forest" data-id="element-140">{item.name}</span>
            </div>
            <div className="mt-3 flex text-gold" data-id="element-141">
              {'★★★★★'.split('').map((star, i) => <span key={i} data-id="element-142">{star}</span>)}
            </div>
          </div>)}
      </div>
    </Section>;
}